export default __webpack_public_path__ + "static/easyTouch-8fac957b6deda3e7377b399dd0e60df8.png";